// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__qEv2A","active":"Footer_active__YaKLN","wide":"Footer_wide__GaAmH"};